export default "__VITE_ASSET__C_P88mn2__"